export class SalesPerson {
	code = ''
	name = ''
	id = ''
}
